import { FormType } from '../../interfaces/form.interface';
import { type ReactiveFormHostMode, ReactiveFormHostState } from './reactive-form-host-state';

export enum ReactiveFormHostRequestButtonType {
    NEW,
    EDIT,
    DELETE,
}

export interface ReactiveFormHostRequestButtonStateOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly fallbackType?: ReactiveFormHostRequestButtonType | undefined;
}

/** Resolves request-button presentation state without depending on the app request-button component. */
export class ReactiveFormHostRequestButtonState {
    public static resolve<TModel>(options: ReactiveFormHostRequestButtonStateOptions<TModel>): ReactiveFormHostRequestButtonType {
        const requestButtonType = ReactiveFormHostRequestButtonState.resolveFromMode(options.state.mode, options.fallbackType);

        options.state.setRequestButtonType(requestButtonType);
        return requestButtonType;
    }

    public static resolveFromMode(
        mode: ReactiveFormHostMode,
        fallbackType: ReactiveFormHostRequestButtonType = ReactiveFormHostRequestButtonType.NEW,
    ): ReactiveFormHostRequestButtonType {
        switch (mode) {
        case 'edit':
            return ReactiveFormHostRequestButtonType.EDIT;
        case 'new':
        case 'duplicate':
            return ReactiveFormHostRequestButtonType.NEW;
        default:
            return fallbackType;
        }
    }

    public static resolveFromFormType(
        formType: FormType | null | undefined,
        fallbackType: ReactiveFormHostRequestButtonType = ReactiveFormHostRequestButtonType.NEW,
    ): ReactiveFormHostRequestButtonType {
        switch (formType) {
        case FormType.EDITION:
            return ReactiveFormHostRequestButtonType.EDIT;
        case FormType.CREATION:
        case FormType.DUPLICATION:
            return ReactiveFormHostRequestButtonType.NEW;
        default:
            return fallbackType;
        }
    }
}
